export default __webpack_public_path__ + "static/media/caption.86818dd3.png";